module.exports = __webpack_public_path__ + "media/images/guides/random-03-cc919dbd04fa914ae886edb7e56977dc.svg";